<template>
    <h2>Engineering Pages</h2>
    <div    class="flex justify-around">
        <div    class="w-3/5 grid-cols-12">
            <!-- List of links that should be shown -->
            <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-5 md:grid-cols-2">
                <!-- Grab each links -->
                <template   v-for="link in links">
                    <li     v-if="canSeeLink(link)"
                            class="col-span-1">
                        <!-- Link to page -->
                        <setting-page-link-with-icon    :href="link.link"
                                                        :icon="link.icon"
                                                        :text="link.text"
                        ></setting-page-link-with-icon>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SettingPageLinkWithIcon from "@/components/SonicuSidebar/SettingPageLinkWithIcon.vue";
import {SidebarLinksPageMixin} from "@/mixins/SidebarLinksPageMixin";

export default {
    name: "EngineeringLinksPage",
    mixins: [SonicuCoreMixin, iconNamesMixin, SidebarLinksPageMixin],
    components: {SettingPageLinkWithIcon},
    emits: [],
    props: {},
    data() {
        return {
            links: [
                {
                    text: 'Roles',
                    link: '/SonicuTools/Roles',
                    permission: 'read_roles',
                    icon: 'icon-group-work',
                },
                {
                    text: 'Permissions',
                    link: '/SonicuTools/Permissions',
                    permission: 'read_permissions',
                    icon: 'icon-user-lock',
                },
                {
                    text: 'Deleted Companies',
                    link: '/SonicuTools/deleted-companies',
                    permission: 'delete_companies',
                    icon: 'icon-city',
                },
                {
                    text: 'Scripts Index',
                    link: '/scripts',
                    permission: 'run_scripts',
                    // The link will only render if the user has access to the scripts.
                    show: () => {
                        return this.hasScriptAccess
                    },
                    icon: 'icon-cli',
                },
                {
                    text: 'Add Banner',
                    link: '/SonicuTools/banners',
                    permission: 'do_anything',
                    icon: 'icon-bubble',
                }
            ],
            hasScriptAccess: false,
        }
    },
    created() {
        this.links = this.parseCompanyLinks(this.links)
    },
    mounted() {
        axios.get('/api-internal/is-sonicu-engineer'
        ).then(response => {
            let data = response.data
            this.hasScriptAccess = data.hasScriptAccess
        })
    },
    methods: {

    },
    computed: {

    },
    watch: {},
}
</script>

<style scoped>

</style>